import {
  DropdownMenu,
  DropdownMenuTrigger
} from "@certa/catalyst/components/Dropdown";

import { UserAvatar, OverlayMenu } from "./components";
import { analyticsService, AnalyticsEvents } from "@certa/analytics";

type UserProfileProps = {
  userName: string;
};

export const UserProfile = (props: UserProfileProps) => {
  const { userName } = props;
  return (
    <DropdownMenu
      onOpenChange={open => {
        open &&
          analyticsService.track(
            AnalyticsEvents.headerEvents.HEADER_CLICK_USERPROFILE_DROPDOWN
          );
      }}
    >
      <DropdownMenuTrigger>
        <UserAvatar userName={userName} />
      </DropdownMenuTrigger>
      <OverlayMenu />
    </DropdownMenu>
  );
};
